export enum PmsStatusEnum {
    Ready,
    Pending
}